const OPTIMIZABLE_EXACT_HOSTS = new Set([
  "abs.twimg.com",
  "ai-primer.com",
  "api.microlink.io",
  "i.pravatar.cc",
  "pbs.twimg.com",
  "www.ai-primer.com",
]);

export function canOptimizeExploreImage({ src }: { src: string }): boolean {
  if (src.startsWith("/")) {
    return true;
  }

  try {
    const url = new URL(src);

    if (url.protocol !== "https:" && url.protocol !== "http:") {
      return false;
    }

    return (
      OPTIMIZABLE_EXACT_HOSTS.has(url.hostname) ||
      url.hostname.endsWith(".blob.vercel-storage.com")
    );
  } catch {
    return false;
  }
}
